import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UnmatchedDevice } from '@app/modules/smart-devices/data/smart-devices.interface';
import { SmartDevicesDialogService } from '@app/modules/smart-devices/dialogs/smart-devices-dialog.service';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';

@Component({
  standalone: false,
  selector: 'sbnb-smart-device-unmatched-devices-table',
  templateUrl: './smart-device-unmatched-devices-table.component.html',
  styleUrls: ['./smart-device-unmatched-devices-table.component.scss'],
})
export class SmartDeviceUnmatchedDevicesTableComponent implements OnInit {
  isMobile$ = this.deviceService.isMobileViewport();
  displayedColumns = ['manufacturer', 'name', 'online', 'actions'];

  @Input() devices: UnmatchedDevice[] = [];
  @Input() canAction = true;
  @Output() deviceMatched = new EventEmitter<UnmatchedDevice>();

  constructor(
    private deviceService: DeviceDetectionService,
    private smartDialogService: SmartDevicesDialogService
  ) { }

  ngOnInit(): void { }

  onMatchClicked(device: UnmatchedDevice) {
    this.smartDialogService.openDeviceEditDialog(device).subscribe((res) => {
      this.deviceMatched.emit(device);
    });
  }
}
